document.addEventListener('DOMContentLoaded', function () {
    function loadVisibleBackgroundImages() {
        $('[data-lazy-background]').each(function () {
            if (elementIsInView(this)) {
                var backgroundImageUrl = $(this).attr('data-lazy-background');
                $(this).css('background-image', 'url("' + backgroundImageUrl + '")');
                $(this).removeAttr('data-lazy-background');
            }
        });
    }

    function elementIsInView(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.scrollY + window.innerHeight) &&
            left < (window.scrollX + window.innerWidth) &&
            (top + height) > window.scrollY &&
            (left + width) > window.scrollX
        );
    }

    $(document).on('scroll', function () {
        loadVisibleBackgroundImages();
    });

    loadVisibleBackgroundImages();
});